import { pathOr } from 'ramda';

import { IState } from '../../store';
import { IPhotoSchema } from '../../types/newbuildingTiledCarousel';

export const getLayout = (state: IState): IPhotoSchema | null => {
  const photos = pathOr([] as IPhotoSchema[], ['offerData', 'offer', 'photos'], state);
  const layout = photos.find(photo => photo.isLayout);

  return layout || null;
};
